import Modal from '@mui/material/Modal';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { locator } from '../../testing/e2e-locator/locator';
import { Button } from '../Button/Button';
import { CloseRoundedIcon } from '../Icons/CloseRoundedIcon';

export const ApplicationQueuedLearnModal = ({
  onClose,
}: {
  onClose: () => void;
}): ReactNode => {
  const { t } = useTranslation();

  return (
    <Modal
      data-testid={locator.components.applicationQueuedLearnModal.root}
      open
      onClose={onClose}
    >
      <div className="modal-content">
        <header
          data-testid={
            locator.components.applicationQueuedLearnModal.header.root
          }
        >
          <h1
            data-testid={
              locator.components.applicationQueuedLearnModal.header.h1
            }
          >
            {t('applicationQueuedLearnModal.title')}
          </h1>
          <button
            aria-label="Close learn more"
            data-testid={
              locator.components.applicationQueuedLearnModal.header.closeButton
            }
            type="button"
            onClick={onClose}
          >
            <CloseRoundedIcon />
          </button>
        </header>
        <div>
          <main
            data-testid={
              locator.components.applicationQueuedLearnModal.main.root
            }
          >
            <p
              data-testid={
                locator.components.applicationQueuedLearnModal.main.p
              }
            >
              {t('applicationQueuedLearnModal.content')}
            </p>
          </main>
          <footer
            data-testid={
              locator.components.applicationQueuedLearnModal.footer.root
            }
          >
            <Button
              data-testid={
                locator.components.applicationQueuedLearnModal.footer
                  .closeButton
              }
              style={{ alignSelf: 'right' }}
              onClick={onClose}
            >
              {t('applicationQueuedLearnModal.close')}
            </Button>
          </footer>
        </div>
      </div>
    </Modal>
  );
};
